import { useEffect, useRef, useState } from "react";

// ─── Three-dot Menu ───────────────────────────────────────────────────────────
const ThreeDotMenu = ({ item, onUpdate, onQueueEdit, onCancel, mode }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div
      ref={ref}
      style={{
        flex: 1,
        display: "flex",
        justifyContent: "flex-end",
        position: "relative",
      }}
    >
      <button
        onClick={(e) => {
          e.stopPropagation();
          setOpen((p) => !p);
          // console.log(e);
        }}
        style={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          border: "none",
          backgroundColor: mode ? "#3b3d43" : "#F3F4F6",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
        title="More actions"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="8" cy="3" r="1.5" fill={mode ? "#fff" : "#374151"} />
          <circle cx="8" cy="8" r="1.5" fill={mode ? "#fff" : "#374151"} />
          <circle cx="8" cy="13" r="1.5" fill={mode ? "#fff" : "#374151"} />
        </svg>
      </button>
      {open && (
        <div
          style={{
            position: "absolute",
            // right: 0,
            // top: 32,
            right: 30,
            top: 0,
            zIndex: 9999,
            backgroundColor: mode ? "#1B1D21" : "#fff",
            border: `1px solid ${mode ? "#3b3d43" : "#E5E7EB"}`,
            borderRadius: 10,
            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
            minWidth: 100,
            overflow: "hidden",
            padding: 5,
          }}
        >
          {[
            {
              // icon: "✏️",
              label: "Update Production",
              action: () => {
                onUpdate(item);
                setOpen(false);
              },
            },
            {
              // icon: "🔢",
              label: "Update Queue No",
              action: () => {
                onQueueEdit(item);
                setOpen(false);
              },
            },
            {
              // icon: "✕",
              label: "Cancel Production",
              action: () => {
                onCancel(item);
                setOpen(false);
              },
              danger: true,
            },
          ].map((opt) => (
            <div
              key={opt.label}
              onClick={(e) => {
                e.stopPropagation();
                opt.action();
              }}
              style={{
                padding: 5,
                fontSize: 13,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 8,
                color: opt.danger ? "#F04438" : mode ? "#fff" : "#374151",
                transition: "background 0.15s",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                borderRadius: 10,
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = mode
                  ? "#323336"
                  : "#F3F4F6")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              <span>{opt.icon}</span> {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ThreeDotMenu;
